module.exports = __webpack_public_path__ + "src/assets/img/szst_xtxt_02@2x.2379dd2e.png";